/**
 * Subdomain detection for storefront URLs.
 *
 * When a user visits `storename.isqroll.co.nz`, we detect the subdomain
 * and render the StorefrontPage directly, bypassing normal routing.
 *
 * Known root domains where the app runs (no subdomain routing):
 * - isqroll.co.nz (production)
 * - isqroll.sidequest.nz (test domain)
 * - localhost / 127.0.0.1 (development)
 */

const ROOT_DOMAINS = ['isqroll.co.nz', 'isqroll.sidequest.nz']

/**
 * Extract a store subdomain from the current hostname.
 * Returns null if on a root domain, www, localhost, or dev environment.
 *
 * Examples:
 *  - "mike-baker.isqroll.co.nz" => "mike-baker"
 *  - "isqroll.co.nz" => null
 *  - "www.isqroll.co.nz" => null
 *  - "localhost" => null
 *  - "127.0.0.1" => null
 */
export function getSubdomain(): string | null {
  const hostname = window.location.hostname

  // Skip for localhost / dev
  if (hostname === 'localhost' || hostname === '127.0.0.1') return null

  // Check each root domain
  for (const root of ROOT_DOMAINS) {
    if (hostname.endsWith(root) && hostname !== root && hostname !== `www.${root}`) {
      const subdomain = hostname.replace(`.${root}`, '')
      // Only return single-level subdomains (no dots)
      if (subdomain && !subdomain.includes('.')) {
        return subdomain
      }
    }
  }

  return null
}
